import ClinicMedic from '../pages/clinic-medic';
import User from '../pages/korisnik/[id]';
import Users from '../pages/korisnik/korisnici';
import Medics from '../pages/medics';
import EditClinic from '../pages/medics/clinicEdit';
import EditMedic from '../pages/medics/edit';
import ViewMedic from '../pages/medics/view';
import PointsAndGamification from '../pages/pointsAndGamification/pointsAndGamification';
import Profile from '../pages/profile/profile';
import ReferralProgram from '../pages/referralProgram/referralProgram';
import ReportsAndStatistics from '../pages/reportsAndStatistics/reportsAndStatistics';
import Vip from '../pages/vips/[id]';
import LoyaltyProgramSettings from '../pages/loyaltyProgramSettings/loyaltyProgramSettings';
import RoleAndPermissions from '../pages/roleAndPermissions/roleAndPermissions';
import AiPravila from '../pages/aiPravila/aiPravila';
import AuditLog from '../pages/auditLog/auditLog';
import Vips from '../pages/vips/vips';
import SingleOrder from '../pages/webshopAndProducts/[id]';
import ProductsPage from '../pages/webshopAndProducts/products';
import DodajProizvod from '../pages/webshopAndProducts/dodaj';
import IzmeniProizvod from '../pages/webshopAndProducts/izmeni/[id]';
import DodajKategoriju from '../pages/webshopAndProducts/kategorije/dodaj';
import IzmeniKategoriju from '../pages/webshopAndProducts/kategorije/izmeni/[id]';
import IzmeniPaket from '../pages/webshopAndProducts/paketi/[id]';
import OrdersPage from '../pages/webshopAndProducts/orders';
import ViewClinic from '../pages/medics/clinic/view';
import UserOrders from '../pages/korisnik/narudzbine/[userId]';
import EditAnnouncement from '../pages/annoucement/[id]';
import PersonalSurvey from '../pages/korisnik/detalji/[id]';
import Annoucement from '../pages/annoucement';
import ViewAgent from '../pages/agent/[id]';
import Agents from '../pages/agents';
import EditAgent from '../pages/agents/edit';
import AgentHome from '../pages/agent-home';
import SubscriptionsSystem from '../pages/subscriptionsSystem';
import SingleSubscriptionHistory from '../pages/subscriptionsSystem/[id]';
import NagradaPage from '../temp/award-event-2026/NagradaPage';
import MobilniInfoPage from '../pages/mobilni-info';
import NotifikacijePage from '../pages/notifikacije';
import NotifikacijaDetail from '../pages/notifikacije/[id]';
import DodajNotifikaciju from '../pages/notifikacije/dodaj';
import IzmeniNotifikaciju from '../pages/notifikacije/izmeni/[id]';
import KvizoviPage from '../pages/kvizovi';
import DodajKviz from '../pages/kvizovi/dodaj';
import IzmeniKviz from '../pages/kvizovi/izmeni/[id]';
import KvizRezultati from '../pages/kvizovi/rezultati/[id]';
import ProtokoliPage from '../pages/protokoli';
import DodajPodkategoriju from '../pages/protokoli/podkategorije/dodaj';
import IzmeniPodkategoriju from '../pages/protokoli/podkategorije/izmeni/[id]';
import DodajProtokol from '../pages/protokoli/dodaj';
import IzmeniProtokol from '../pages/protokoli/izmeni/[id]';
import VerzijeProtokola from '../pages/protokoli/verzije/[id]';

import { adminRoles, otherRoles, agentRoles, clientPageRoles } from './roles';

export { adminRoles, otherRoles, agentRoles, clientPageRoles };

// Admin pages are gated by `permissions` (all required, from the roles-and-permissions
// matrix), not by role: an admin the super admin narrowed loses the page, and a mentor or
// agent granted the permission gains it. Roles in `allowedRoles` other than the admin ones
// still pass by role (their pages scope themselves). `menuGroup` instead of `permissions`
// means "any visible tab of that menu group" (pages that switch tabs by ?tab=).
const SCOPE = 'scope:all';
const USERS = ['users:read', SCOPE];
const NETWORK = ['network:manage', SCOPE];
const CATALOG = ['catalog:manage'];
const CONTENT = ['content:manage'];
const ORDERS = ['commerce:orders:read', SCOPE];
const SUBSCRIPTIONS = ['commerce:subscriptions:manage', SCOPE];
const LOYALTY = ['loyalty:manage'];
const VIP = ['users:write', SCOPE];
const REPORTS = ['reports:read', SCOPE];

export const routes = [
  {
    id: 1,
    isAdminRoute: true,
    path: '/korisnici',
    menuGroup: 'korisnici',
    element: <Users />,
    allowedRoles: adminRoles,
  },
  {
    id: 2,
    isAdminRoute: true,
    path: '/korisnik/:id',
    permissions: USERS,
    element: <User />,
    allowedRoles: adminRoles,
  },
  {
    id: 3,
    isAdminRoute: true,
    path: '/points-and-gamification',
    permissions: LOYALTY,
    element: <PointsAndGamification />,
    allowedRoles: adminRoles,
  },
  {
    id: 4,
    isAdminRoute: true,
    path: '/vips',
    permissions: VIP,
    element: <Vips />,
    allowedRoles: adminRoles,
  },
  {
    id: 5,
    isAdminRoute: true,
    path: '/vip/:id',
    permissions: VIP,
    element: <Vip />,
    allowedRoles: adminRoles,
  },
  {
    id: 6,
    isAdminRoute: true,
    path: '/proizvodi',
    permissions: CATALOG,
    element: <ProductsPage />,
    allowedRoles: adminRoles,
  },
  {
    id: 38,
    isAdminRoute: true,
    path: '/proizvodi/dodaj',
    permissions: CATALOG,
    element: <DodajProizvod />,
    allowedRoles: adminRoles,
  },
  {
    id: 39,
    isAdminRoute: true,
    path: '/proizvodi/izmeni/:id',
    permissions: CATALOG,
    element: <IzmeniProizvod />,
    allowedRoles: adminRoles,
  },
  {
    id: 40,
    isAdminRoute: true,
    path: '/proizvodi/kategorije/dodaj',
    permissions: CATALOG,
    element: <DodajKategoriju />,
    allowedRoles: adminRoles,
  },
  {
    id: 41,
    isAdminRoute: true,
    path: '/proizvodi/kategorije/izmeni/:id',
    permissions: CATALOG,
    element: <IzmeniKategoriju />,
    allowedRoles: adminRoles,
  },
  {
    id: 49,
    isAdminRoute: true,
    path: '/proizvodi/paketi/:id',
    permissions: CATALOG,
    element: <IzmeniPaket />,
    allowedRoles: adminRoles,
  },
  {
    id: 27,
    isAdminRoute: true,
    path: '/narudzbine',
    permissions: ORDERS,
    element: <OrdersPage />,
    allowedRoles: adminRoles,
  },
  {
    id: 7,
    isAdminRoute: true,
    path: '/order/:id',
    permissions: ORDERS,
    element: <SingleOrder />,
    allowedRoles: adminRoles,
  },
  {
    id: 8,
    isAdminRoute: true,
    path: '/referral-program',
    permissions: LOYALTY,
    element: <ReferralProgram />,
    allowedRoles: adminRoles,
  },
  {
    id: 9,
    isAdminRoute: true,
    path: '/medics',
    permissions: NETWORK,
    element: <Medics />,
    allowedRoles: adminRoles,
  },
  {
    id: 10,
    isAdminRoute: true,
    path: '/medics/edit/:id',
    permissions: NETWORK,
    element: <EditMedic />,
    allowedRoles: adminRoles,
  },
  {
    id: 11,
    isAdminRoute: true,
    path: '/medics/view/:id',
    permissions: NETWORK,
    element: <ViewMedic />,
    // Clinic owners get a read-only view of their own clinic's mentors.
    allowedRoles: [...adminRoles, 'clinic_owner'],
  },
  {
    id: 12,
    isAdminRoute: true,
    path: '/clinic/edit/:id',
    permissions: NETWORK,
    element: <EditClinic />,
    allowedRoles: adminRoles,
  },
  {
    id: 13,
    isAdminRoute: true,
    path: '/reports-and-statistics',
    permissions: REPORTS,
    element: <ReportsAndStatistics />,
    allowedRoles: adminRoles,
  },
  {
    id: 14,
    isAdminRoute: false,
    path: '/profile',
    element: <Profile />,
    allowedRoles: [...adminRoles, ...otherRoles, ...agentRoles],
  },
  {
    id: 15,
    isAdminRoute: false,
    path: '/clinic-medic',
    element: <ClinicMedic />,
    allowedRoles: otherRoles,
  },
  {
    id: 16,
    isAdminRoute: true,
    path: '/clinic/view/:id',
    permissions: NETWORK,
    element: <ViewClinic />,
    allowedRoles: adminRoles,
  },
  {
    id: 17,
    isAdminRoute: true,
    path: '/korisnik/narudzbine/:userId',
    element: <UserOrders />,
    allowedRoles: clientPageRoles,
  },
  {
    id: 18,
    isAdminRoute: true,
    path: '/korisnik/detalji/:id',
    element: <PersonalSurvey />,
    allowedRoles: clientPageRoles,
  },
  {
    id: 19,
    isAdminRoute: true,
    path: '/objave',
    permissions: CONTENT,
    element: <Annoucement />,
    allowedRoles: adminRoles,
  },
  {
    id: 20,
    isAdminRoute: true,
    path: '/objave/pregled',
    permissions: CONTENT,
    element: <EditAnnouncement />,
    allowedRoles: adminRoles,
  },
  {
    id: 21,
    isAdminRoute: true,
    path: '/objave/:id',
    permissions: CONTENT,
    element: <EditAnnouncement />,
    allowedRoles: adminRoles,
  },
  {
    id: 22,
    isAdminRoute: true,
    path: '/agenti/:id',
    permissions: NETWORK,
    element: <ViewAgent />,
    allowedRoles: adminRoles,
  },
  {
    id: 42,
    isAdminRoute: true,
    path: '/agenti',
    permissions: NETWORK,
    element: <Agents />,
    allowedRoles: adminRoles,
  },
  {
    id: 43,
    isAdminRoute: true,
    path: '/agenti/edit/:id',
    permissions: NETWORK,
    element: <EditAgent />,
    allowedRoles: adminRoles,
  },
  {
    id: 44,
    isAdminRoute: false,
    path: '/agent-home',
    element: <AgentHome />,
    allowedRoles: agentRoles,
  },
  {
    id: 23,
    isAdminRoute: true,
    path: '/pretplatnicki-sistem',
    permissions: SUBSCRIPTIONS,
    element: <SubscriptionsSystem />,
    allowedRoles: adminRoles,
  },
  {
    id: 24,
    isAdminRoute: true,
    path: '/pretplatnicki-sistem/:id',
    permissions: SUBSCRIPTIONS,
    element: <SingleSubscriptionHistory />,
    allowedRoles: adminRoles,
  },
  {
    id: 25,
    isAdminRoute: true,
    path: '/nagrada',
    permissions: REPORTS,
    element: <NagradaPage />,
    allowedRoles: adminRoles,
  },
  {
    id: 26,
    isAdminRoute: true,
    path: '/mobilni-info',
    permissions: CONTENT,
    element: <MobilniInfoPage />,
    allowedRoles: adminRoles,
  },
  {
    id: 28,
    isAdminRoute: true,
    path: '/notifikacije',
    permissions: CONTENT,
    element: <NotifikacijePage />,
    allowedRoles: adminRoles,
  },
  {
    id: 29,
    isAdminRoute: true,
    path: '/notifikacije/dodaj',
    permissions: CONTENT,
    element: <DodajNotifikaciju />,
    allowedRoles: adminRoles,
  },
  {
    id: 30,
    isAdminRoute: true,
    path: '/notifikacije/:id',
    permissions: CONTENT,
    element: <NotifikacijaDetail />,
    allowedRoles: adminRoles,
  },
  {
    id: 31,
    isAdminRoute: true,
    path: '/notifikacije/izmeni/:id',
    permissions: CONTENT,
    element: <IzmeniNotifikaciju />,
    allowedRoles: adminRoles,
  },
  {
    id: 32,
    isAdminRoute: true,
    path: '/protokoli',
    permissions: CATALOG,
    element: <ProtokoliPage />,
    allowedRoles: adminRoles,
  },
  {
    id: 50,
    isAdminRoute: true,
    path: '/protokoli/podkategorije/dodaj',
    permissions: CATALOG,
    element: <DodajPodkategoriju />,
    allowedRoles: adminRoles,
  },
  {
    id: 51,
    isAdminRoute: true,
    path: '/protokoli/podkategorije/izmeni/:id',
    permissions: CATALOG,
    element: <IzmeniPodkategoriju />,
    allowedRoles: adminRoles,
  },
  {
    id: 35,
    isAdminRoute: true,
    path: '/protokoli/dodaj',
    permissions: CATALOG,
    element: <DodajProtokol />,
    allowedRoles: adminRoles,
  },
  {
    id: 36,
    isAdminRoute: true,
    path: '/protokoli/izmeni/:id',
    permissions: CATALOG,
    element: <IzmeniProtokol />,
    allowedRoles: adminRoles,
  },
  {
    id: 37,
    isAdminRoute: true,
    path: '/protokoli/verzije/:id',
    permissions: CATALOG,
    element: <VerzijeProtokola />,
    allowedRoles: adminRoles,
  },
  {
    id: 45,
    isAdminRoute: true,
    path: '/kvizovi',
    permissions: CONTENT,
    element: <KvizoviPage />,
    allowedRoles: adminRoles,
  },
  {
    id: 46,
    isAdminRoute: true,
    path: '/kvizovi/dodaj',
    permissions: CONTENT,
    element: <DodajKviz />,
    allowedRoles: adminRoles,
  },
  {
    id: 47,
    isAdminRoute: true,
    path: '/kvizovi/izmeni/:id',
    permissions: CONTENT,
    element: <IzmeniKviz />,
    allowedRoles: adminRoles,
  },
  {
    id: 48,
    isAdminRoute: true,
    path: '/kvizovi/rezultati/:id',
    permissions: CONTENT,
    element: <KvizRezultati />,
    allowedRoles: adminRoles,
  },
  {
    id: 49,
    isAdminRoute: true,
    path: '/role-i-permisije',
    permissions: ['roles:read'],
    element: <RoleAndPermissions />,
    allowedRoles: adminRoles,
  },
  {
    id: 50,
    isAdminRoute: true,
    path: '/ai-pravila',
    permissions: ['ai:outreach:read'],
    element: <AiPravila />,
    // The page itself checks ai:outreach:read / ai:outreach:manage.
    allowedRoles: adminRoles,
  },
  {
    id: 52,
    isAdminRoute: true,
    path: '/istorija-akcija',
    permissions: ['audit:read'],
    element: <AuditLog />,
    // The page itself checks audit:read.
    allowedRoles: adminRoles,
  },
  {
    id: 53,
    isAdminRoute: true,
    path: '/lojalnost-podesavanja',
    permissions: LOYALTY,
    element: <LoyaltyProgramSettings />,
    allowedRoles: adminRoles,
  },
];
